import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClienteService } from '../http-cliente.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class BannersHomeService {
  private url = environment.apiURL;
  constructor(private readonly _http: HttpClienteService, private readonly http: HttpClient) {}

  getPresignedURL(data: any){
    const query = `${this.url}/wcl-document/presigned-url`
    return this._http.post(query, data)
  }
  // Método para subir archivos al Blob Storage de Azure
  uploadFileToBlob(preSignedUrl: string, file: File): Observable<any> {
    const headers = new HttpHeaders({
      'x-ms-blob-type': 'BlockBlob', // Tipo de blob específico para Azure
    });
  
    // Realiza la solicitud PUT usando la URL pre-firmada sin ningún encabezado de autenticación ni cookies
    return this.http.put(preSignedUrl, file, {
      headers,
      observe: 'response',
      withCredentials: false,
    });
  }  
  getBannerSave(data: any){
    const query = `${this.url}/wcl-document/banner-save`
    return this._http.post(query, data)
  }
  // Tipos de archivo y selectores (grupo de precios, zona, segmento) para la segmentación
  getBannerFilters() {
    const query = `${this.url}/wcl-customer/get-bo-ally-file-filters`;
    return this._http.get(query);
  }
  getBannerCustomers(filters: { sector: string[]; zone: string[]; schema: string[]; segment: string[] }) {
    const query = `${this.url}/wcl-customer/get-bo-ally-file-customer`;
    return this._http.post(query, filters);
  }
  getBannerList() {
    const query = `${this.url}/wcl-customer/get-bo-blob-files-list-by-module?module=BANNER`;
    return this._http.get(query);
  }
  saveBannerFiles(data: any[]) {
    const query = `${this.url}/wcl-customer/blob-files-banner-save`;
    return this._http.post(query, data);
  }
}
